import React from 'react';
import { ColumnBar } from './styles';

const Column: React.FC<any> = ({ ...props }) => {
  return <ColumnBar {...props} />;
};

export default Column;
